import React, { useState } from 'react';
import DriverList from './DriverList';
import DriverForm from './DriverForm';
import { Driver } from '../../../types/saas';

const DriverManager: React.FC = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingDriver, setEditingDriver] = useState<Driver | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleAdd = () => {
    setEditingDriver(null);
    setShowForm(true);
  };

  const handleEdit = (driver: Driver) => {
    setEditingDriver(driver);
    setShowForm(true);
  };

  const handleClose = () => {
    setShowForm(false);
    setEditingDriver(null);
  };

  const handleSave = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div>
      <DriverList
        onEdit={handleEdit}
        onAdd={handleAdd}
        refreshTrigger={refreshTrigger}
      />
      
      {showForm && (
        <DriverForm
          driver={editingDriver}
          onClose={handleClose}
          onSave={handleSave}
        />
      )}
    </div>
  );
};

export default DriverManager;
